import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { Cassette } from 'src/app/domain/cassette';
import { ESamplingMode } from 'src/app/domain/enums/sampling-mode';
import { Operator } from 'src/app/domain/operator';
import { Pompe } from 'src/app/domain/pompe';

@Component({
    selector: 'app-init-operator-box',
    templateUrl: 'init-operator-box.html',
    styleUrls: ['./init-operator-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class InitOperatorBoxDialog implements OnInit {

    Model: Operator[] = [];
    CassetteCount: number = 1;
    private size: number = 0;
    private samplingMode?: ESamplingMode;


    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<InitOperatorBoxDialog>) {
        if (data) {
            this.size = data.opCount;
            this.CassetteCount = data.cassetteCount;
            this.samplingMode = data.samplingMode;
            this.setOperatorList();
        }
    }

    ngOnInit() {
    }

    addOperator() {
        this.size++;
        this.setOperatorList()
    }

    removeOperator() {
        this.size--;
        this.setOperatorList()
    }

    addCassette() {
        this.CassetteCount++;
    }

    removeCassette() {
        this.CassetteCount--;
    }

    setOperatorList() {
        this.Model = [];
        for (let i = 0; i < this.size; i++)
            this.Model.push(new Operator({Position: i + 1}))
    }

    canRemove() {
        return this.Model.length > 0
    }

    canAdd() {
        return true;
        // return ((this.samplingMode === ESamplingMode.Single || this.samplingMode === ESamplingMode.Successive) && this.Model.length === 0) ||
        //     (this.samplingMode === ESamplingMode.Simultaneous || this.samplingMode === ESamplingMode.SuccessiveAndSimultaneous)
    }

    canRemoveCassette() {
        return this.CassetteCount > 0
    }


    canFinish() {
        return true;
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {
        if (!this.canFinish()) {
            return;
        }

        this.Model.forEach(x => {
            for (let i = 0; i < this.CassetteCount; i++) {
                x.CassetteList.push(new Cassette({ Pompe: new Pompe() }))
            }
        });
        this.dialogRef.close(this.Model);
    }
}
